import { StripePublicConfig } from "@cruisen/contract"
import sharedStyles from "../sharedStyles.module.scss"
import styles from "./styles.module.scss"
import ArrowBackOutline from "~icons/eva/arrow-back-outline"
import CheckmarkCircleOutline from "~icons/eva/checkmark-circle-2-outline"
import { formatCurrency } from "@cruisen/i18n"
import { calculateDiscountedPrice } from "../../../../../utils/discounts"
import Config from "../../../../../config"

export const Subscription = ({
  onSubmit,
  goBack,
  stripeConfigPrice,
}: {
  onSubmit: () => void
  goBack: () => void
  stripeConfigPrice: StripePublicConfig["prices"][0]
}) => {
  const priceAmount = stripeConfigPrice?.amount / 100
  const { activePrice } =
    stripeConfigPrice?.coupons && stripeConfigPrice?.coupons?.length > 0
      ? calculateDiscountedPrice(priceAmount, stripeConfigPrice?.coupons[0])
      : { activePrice: priceAmount }
  const benefits = [
    "Acquire new and grow customers",
    "Increase top line sales",
    "Achieve faster time-to-booking",
    "Delight your clients",
  ]

  return (
    <div className={sharedStyles.form}>
      <div className={sharedStyles.inputsContainer}>
        <p className={styles.stepDescription}>
          Start your free {Config.stripeDefaultTrialPeriodDays}-day trial today! There will be no
          charge until it ends.
        </p>
        <div className={styles.planCardBorder}>
          <div className={styles.planCardWrapper}>
            <div className={styles.planCardGradientBackground}>
              <div className={styles.planCard}>
                <div className={styles.planInfo}>
                  <div className={styles.price}>
                    <span className={styles.newPrice}>{formatCurrency(0)}</span>
                    <span className={styles.oldPrice}>{formatCurrency(activePrice)}</span>
                  </div>
                  <p className={styles.period}>first {Config.stripeDefaultTrialPeriodDays} days</p>
                </div>
                <div className={styles.planBreakdownWrapper}>
                  <div className={styles.planBreakdown}>
                    <div className={styles.trialRow}>
                      <p>{Config.stripeDefaultTrialPeriodDays}-day trial</p>
                      <p className={styles.rowPrice}>{formatCurrency(0)}</p>
                    </div>
                    <div className={styles.nextMonthRow}>
                      <p>Monthly</p>
                      <p className={styles.rowPrice}>{formatCurrency(activePrice)}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.benefitsContainer}>
                {benefits.map((benefit, index) => (
                  <div key={index} className={styles.benefit}>
                    <CheckmarkCircleOutline className={styles.benefitIcon} />
                    <p>{benefit}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        type="button"
        data-testid="go-to-payment-details-button"
        className={sharedStyles.button}
        onClick={() => onSubmit()}
      >
        Next
      </button>
      <button type="button" className={sharedStyles.previousButton} onClick={() => goBack()}>
        <ArrowBackOutline className={sharedStyles.previousIcon} /> Previous page
      </button>
    </div>
  )
}
